import styled from "styled-components";

export const OptionButtonMenuContainer = styled.button`
  display: flex;
  align-items: center;
  text-align: start;
  padding: 2%;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.15) 0rem 0rem 0.125rem 0.094rem;
  font-size: 0.75em;
  gap: 0.813rem;
  background-color: var(--chat-background);
  color: white;
  height: 2.7em;
  transition: filter 0.2s;
  border: 1px solid var(--white);

  img {
    width: 1.75rem;
  }
  &:hover {
    filter: brightness(0.9);
    color: var(--white);
    background-color: var(--dark-blue);

  }
  &:active {
    transform: scale(0.95);
    box-shadow: rgba(0, 0, 0, 0.2); 
    delay: 0.5s;
  }

  @media (max-width: 42.813rem) {
    font-size: 0.75em;
    gap: 0.313rem;

    img {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`;
